import { string, object, SchemaOf, number } from 'yup'

export interface IRequestMaintenances {
    realEstateApartmentId: number
    email: string
    phone: string
    request: string
}

const maintenancesSchema: SchemaOf<IRequestMaintenances> = object().shape({
    realEstateApartmentId: number().required('Escolha o apartamento da sua solicitação.'),
    email: string().email('E-mail inválido.').required('Preencha o campo com seu e-mail.'),
    phone: string()
        .required('Preencha o campo com seu telefone.')
        .min(10, 'O campo telefone está incompleto')
        .transform((value) => value.replace(/[^\d]+/gi, '')),
    request: string().required('Preencha o campo com sua solicitação.'),
})

export default maintenancesSchema
